import BaseApi from '@core/api/model';

import clock from '@plugins/dayjs';

export class NotificationApi extends BaseApi {
    static resource = 'notifications';

    static mockItemCount = 7;
    static mockSoftDelete = true;

    get endpoints() {
        return {
            ...super.endpoints,
            read: this.read.bind(this),
            read_before: this.read_before.bind(this),
            clear_before: this.clear_before.bind(this)
        };
    }

    get mock_endpoints() {
        return {
            ...super.mock_endpoints,
            read: this.read_mock.bind(this),
            read_before: this.read_before_mock.bind(this),
            clear_before: this.clear_before_mock.bind(this)
        };
    }

    async read(id, value = true, config = { base_url: null }) {
        return this.patch(id, { read: value }, config);
    }

    async read_mock(id, value = true) {
        const items = this._getMocked();
        const index = items.findIndex(item => item.id === id);

        if (index === -1) {
            return {
                status: 'fail',
                message: 'Not found'
            };
        }

        if (value) {
            items[`${index}`] = {
                ...items[`${index}`],
                viewed_at: new Date().toISOString()
            };
        } else {
            items[`${index}`] = {
                ...items[`${index}`],
                viewed_at: null
            };
        }

        this._saveMocked(items);

        let response = {
            status: 'success',
            data: items[`${index}`]
        };

        return this._respond(response, () => {
            response.data = this._filterResponseData(response.data);
            response.data = this._filterPatchResponseData(response.data);

            this._updateItemInCollections(id, response.data);
            this._insertModel(response.data, this.ApiResponseFormatEnum.DETAIL);
        });
    }

    async read_before(older_than, config = { base_url: null }) {
        let response = await BaseApi.api.post(`${this.base_url}/read`, { older_than }, config);

        return this._respond(response, () => {
            response.data = this._filterResponseData(response.data);

            response.data.forEach(item => {
                this._updateItemInCollections(item.id, item);
                this._insertModel(item, this.ApiResponseFormatEnum.DETAIL);
            });
        });
    }

    async read_before_mock(older_than) {
        const items = this._getMocked();

        older_than = clock(older_than);

        if (items.length === 0) {
            return {
                status: 'success',
                data: []
            };
        }

        let updatedItems = items.map(item => {
            if (clock(item.created_at).isBefore(older_than)) {
                item.viewed_at = clock().toISOString();
            }
            return item;
        });

        this._saveMocked(updatedItems);

        let response = {
            status: 'success',
            data: updatedItems
        };

        return this._respond(response, () => {
            response.data = this._filterResponseData(response.data);

            response.data.forEach(item => {
                this._updateItemInCollections(item.id, item);
                this._insertModel(item, this.ApiResponseFormatEnum.DETAIL);
            });
        });
    }

    async clear_before(older_than, config = { base_url: null }) {
        let response = await BaseApi.api.remove(`${this.base_url}`, { ...config, params: { older_than } });

        return this._respond(response, () => {
            response.data = this._filterResponseData(response.data);

            response.data.forEach(item => {
                this._removeItemInCollections(item.id);
                this.model.delete(item.id);
            });
        });
    }

    async clear_before_mock(older_than) {
        const items = this._getMocked();

        older_than = clock(older_than);

        if (items.length === 0) {
            return {
                status: 'success',
                data: []
            };
        }

        let clearedItems = items.filter(item => {
            if (clock(item.created_at).isBefore(older_than)) {
                return true;
            }
            return false;
        });

        this._saveMocked(clearedItems);

        let response = {
            status: 'success',
            data: clearedItems
        };

        return this._respond(response, () => {
            response.data = this._filterResponseData(response.data);

            response.data.forEach(item => {
                this._removeItemInCollections(item.id);
                this.model.delete(item.id);
            });
        });
    }
}

export default NotificationApi;
